import { create } from 'zustand'
import api from '../services/api'

export type ThemeName = 'chiaro' | 'scuro' | 'lcars' | 'cyberpunk' | 'matrix' | 'dracula' | 'nord'

const DARK_THEMES: ThemeName[] = ['scuro', 'lcars', 'cyberpunk', 'matrix', 'dracula', 'nord']
const VALID_THEMES: ThemeName[] = ['chiaro', 'scuro', 'lcars', 'cyberpunk', 'matrix', 'dracula', 'nord']

function applyThemeToDOM(theme: ThemeName) {
  const html = document.documentElement
  html.classList.add('theme-transitioning')
  html.setAttribute('data-theme', theme)

  if (DARK_THEMES.includes(theme)) {
    html.classList.add('theme-dark')
  } else {
    html.classList.remove('theme-dark')
  }

  // Font override per temi speciali
  if (theme === 'lcars') {
    document.body.style.fontFamily = "'Antonio', 'Helvetica Neue', Arial, sans-serif"
  } else if (theme === 'cyberpunk') {
    document.body.style.fontFamily = "'Rajdhani', 'Inter', system-ui, sans-serif"
  } else if (theme === 'matrix') {
    document.body.style.fontFamily = "'Share Tech Mono', 'Courier New', monospace"
  } else {
    document.body.style.fontFamily = "'Inter', system-ui, -apple-system, sans-serif"
  }

  setTimeout(() => html.classList.remove('theme-transitioning'), 350)
}

function getInitialTheme(): ThemeName {
  const saved = localStorage.getItem('erp_theme') as ThemeName | null
  if (saved && VALID_THEMES.includes(saved)) return saved
  return 'chiaro'
}

// Apply before React renders
const initialTheme = getInitialTheme()
applyThemeToDOM(initialTheme)

interface ThemeState {
  theme: ThemeName
  setTheme: (theme: ThemeName) => void
  loadThemeFromServer: () => Promise<void>
  saveThemeToServer: (theme: ThemeName) => Promise<void>
}

export const useThemeStore = create<ThemeState>((set) => ({
  theme: initialTheme,

  setTheme: (theme: ThemeName) => {
    localStorage.setItem('erp_theme', theme)
    applyThemeToDOM(theme)
    set({ theme })
  },

  loadThemeFromServer: async () => {
    try {
      const res = await api.get('/v1/anagrafiche/tenant/settings/theme')
      const serverTheme = res.data.theme as ThemeName
      if (serverTheme && VALID_THEMES.includes(serverTheme)) {
        localStorage.setItem('erp_theme', serverTheme)
        applyThemeToDOM(serverTheme)
        set({ theme: serverTheme })
      }
    } catch {
      // Silenzioso — usa tema locale
    }
  },

  saveThemeToServer: async (theme: ThemeName) => {
    try {
      await api.put('/v1/anagrafiche/tenant/settings/theme', { theme })
    } catch {
      // Silenzioso — tema gia' salvato localmente
    }
  },
}))
